import Vue from "vue";
import Vuex from "vuex";

// Modules
import auth from "./modules/auth";
import settings from "./modules/settings";
import managers from "./modules/managers";
import patients from "./modules/patients";
import controlDoctors from "./modules/control-doctors";
import practitioners from "./modules/practitioners";
import subscribers from "./modules/subscribers";
import medicalFiles from "./modules/medicalFiles";
import professions from "./modules/professions";
import specialties from "./modules/specialties";
import consultationType from "./modules/consultationTypes";
import institutions from "./modules/institutions";
import countries from "./modules/countries";
import roles from "./modules/roles";
import rdv from "./modules/rdv";
import treatments from "./modules/treatments";
import allergies from "./modules/allergies";
import physicalExams from "./modules/exams/physical";
import complementaryExams from "./modules/exams/complementary";
import affiliations from "./modules/affiliations";
import obstetricConsultations from "./modules/consultations/obstetric";
import prenatalConsultations from "./modules/consultations/prenatal";
import generalConsultations from "./modules/consultations/general";
import ultrasounds from "./modules/ultrasounds";
import hospitalisations from "./modules/hospitalisations";
import reasons from "./modules/reasons";
import obstetricParameters from "./modules/parameters/obstetric";
import antecedents from "./modules/antecedents";
import conclusions from "./modules/conclusions";
import commonParameters from "./modules/parameters/common";
import errors from "./modules/errors";
import results from "./modules/results";
import currentTreatments from "./modules/treatments/current";
import notificationCount from "./modules/notification-bell/index";
import auteurs from "./modules/auteurs/index";
import loadingScreen from "./modules/loader/index";
import password from "./modules/passwords/index";
import requiredConfirmationRoutes from "./modules/routes/index";
import drugs from "./modules/drugs/index";
import prescriptions from "./modules/prescriptions/index";
import uploadFile from "./modules/files/index";
import cardiologies from "./modules/consultations/cardiology";
import examenCardio from "./modules/exams/cardiology";
import question from "./modules/questions/index";
import suivis from "./modules/suivis/index";
import specialtyFollowed from "./modules/specialtyFollowed/index";
import medicalAdvice from "./modules/medical-advice/index";
import adviceResponse from "./modules/advice-response/index";
import doctorAdvice from "./modules/doctor-advice/index";
import followUpCategories from "./modules/follow-up-categories/index";
import todoList from "./modules/todo-list/index";
import manuscrit from "./modules/consultations/manuscrit";
import categoriePrestation from "./modules/category-prestation";
import prestation from "./modules/prestation";
import etablissementPrestation from "./modules/etablissement-prestations";
import etablissementPrice from "./modules/etablissement-prices";
import facture from "./modules/factures";
import comptable from "./modules/comptable";
import assistante from "./modules/assistante";
import timeline from "./modules/timeline";
import operatoire from "@/store/modules/compte-rendu/operatoire";
import groupeActivite from "./modules/groupe-activite/index";
import kinesitherapie from "./modules/consultations/kinesitherapie";
import partner from "./modules/partner";
import regions from "./modules/regions";
import partenaires from "./modules/partenaires-list";
import paiement from "./modules/paiement";
import association from "./modules/association";
import factureAvis from "./modules/factureAvis";
import ama from "./modules/ama";
import MedecinControle from "./modules/medecin-referent";
import chat from "./modules/chat";
import validation from "./modules/validation";
import alerte from "./modules/alertes";
import groupes from "./modules/groupes";
import medsurlinkmobile from "./modules/medsurlink-mobile";
// import ePrescription from './modules/ePrescription';

//import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);
export const store = new Vuex.Store({
  modules: {
    groupeActivite,
    MedecinControle,
    operatoire,
    comptable,
    assistante,
    timeline,
    facture,
    etablissementPrestation,
    etablissementPrice,
    prestation,
    categoriePrestation,
    auth,
    settings,
    managers,
    patients,
    controlDoctors,
    practitioners,
    subscribers,
    medicalFiles,
    professions,
    specialties,
    consultationType,
    institutions,
    countries,
    roles,
    //partners,
    rdv,
    treatments,
    allergies,
    physicalExams,
    complementaryExams,
    affiliations,
    obstetricConsultations,
    prenatalConsultations,
    generalConsultations,
    ultrasounds,
    hospitalisations,
    reasons,
    obstetricParameters,
    antecedents,
    conclusions,
    errors,
    commonParameters,
    results,
    currentTreatments,
    notificationCount,
    auteurs,
    loadingScreen,
    password,
    requiredConfirmationRoutes,
    drugs,
    prescriptions,
    uploadFile,
    cardiologies,
    examenCardio,
    question,
    suivis,
    specialtyFollowed,
    medicalAdvice,
    adviceResponse,
    doctorAdvice,
    followUpCategories,
    todoList,
    manuscrit,
    kinesitherapie,
    partner,
    regions,
    partenaires,
    paiement,
    association,
    factureAvis,
    ama,
    chat,
    validation,
    alerte,
    groupes,
    medsurlinkmobile,
    // ePrescription
  },
  //plugins: [createPersistedState()]
});
